export default "__VITE_ASSET__77fba325__"